import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'react-bootstrap'
import dayjs from 'dayjs'
import SearchButton from '../../../common/Buttons/SearchButton'
import * as styles from './_PendingApprovalProfilesList.scss'
import FieldGroup from '../../../common/forms/FieldGroup'
import Pager from '../../../common/Pager'
import Spinner from '../../../common/Spinners/Spinner'
import history from '../../../core/history'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../AdviserProfileEditor/AdviserProfileEditorContainer/adviserProfileEditorContainerActions'

function columnHeader(displayName, columnName, sortColumn, sortAscending, orderBy) {
  return (
    <a className={styles['column-header']} onClick={() => orderBy(columnName)}>
      {displayName} {columnName === sortColumn ? (sortAscending ? '↑' : '↓') : ''}
    </a>
  )
}

function renderProfile(profile, index, setEditorAdviserId) {
  const adviserName = `${profile.firstName} ${profile.lastName}`
  const adviserNameNoSpace = adviserName.split(' ').join('_')
  const isBlacklisted = profile.adviserStatusCodeId === 3

  return (
    <tr key={index} className={isBlacklisted ? styles.blacklisted : ''}>
      <td>
        <span className={`${styles.status} ${profile.hasPendingProfile ? styles.pending : styles.wip}`}>
          {profile.hasPendingProfile ? 'Pending Approval' : 'Work In Progress'}
        </span>
      </td>

      <td>{profile.ifaCode}</td>

      <td className={isBlacklisted ? styles.blacklisted : ''}>
        {adviserName}
      </td>

      <td className={isBlacklisted ? styles.blacklisted : ''}>
        {profile.company}
      </td>

      <td>{dayjs(profile.dateCreatedUtc).format('MMM YYYY')}</td>
      <td>{dayjs(profile.dateModifiedUtc).format('MMM YYYY')}</td>
      <td>{dayjs(profile.datePublished).format('MMM YYYY')}</td>

      <td>{profile.whoModified}</td>

      <td className={styles['center-align']}>

        {/* Pending Approval */}
        {profile.hasPendingProfile && (
          <button
            className={styles['approve-btn']}
            onClick={() =>
              history.push(`/administration/pendingapprovalAdviserProfiles/${profile.adviserId}/edit`)
            }
          >
            Approve
          </button>
        )}

        {/* Work In Progress */}
        {!profile.hasPendingProfile && (
          <div className={styles['action-group']}>

            <button
              className={styles['secondary-btn']}
              disabled={isBlacklisted}
              onClick={() =>
                history.push(`/adviser/${encodeURIComponent(adviserNameNoSpace)}/${profile.adviserId}/profile/view`)
              }
            >
              View
            </button>

            <button
              className={styles['approve-btn']}
              onClick={() => {
                setEditorAdviserId(profile.adviserId)
                history.push(`/adviser/${profile.adviserId}/profile/edit`)
              }}
            >
              Edit
            </button>

          </div>
        )}
      </td>
    </tr>
  )
}

const PendingApprovalProfilesList = ({
  profiles,
  searchTerm,
  setSearchTerm,
  filter,
  setFilter,
  fetchingProfiles,
  currentPage,
  setPage,
  numPages,
  setEditorAdviserId,
  orderBy,
  orderingBy,
  sortAscending
}) => {

  const onSearch = (e) => {
    e.preventDefault()
    setPage(1)
  }

  const onClear = () => {
    setSearchTerm('')
    setPage(1)
  }

  return (
    <div className={styles.container}>

      <h1 className={styles.heading}>Find an IFA profiles dashboard</h1>

      <div className={styles['content-wrapper']}>

        {/* Search + Tabs */}
        <div className={styles['header-row']}>

          <form onSubmit={onSearch} className={styles['search-form']}>
            <FieldGroup
              value={searchTerm}
              handleChange={setSearchTerm}
              placeholder="Search profiles"
            />
            <SearchButton />
            <button type="button" className={styles['clear-button']} onClick={onClear}>Clear</button>
          </form>

          {/* ✅ FIXED TABS */}
          <div className={styles['tab-group']}>

            <button
              className={`${styles['tab-button']} ${
                filter === 'workInProgress' ? styles.inactive : styles.active
              }`}
              onClick={() => setFilter('workInProgress')}
              disabled={filter === 'workInProgress'}
            >
              Work in progress and published
            </button>

            <button
              className={`${styles['tab-button']} ${
                filter === 'pendingApproval' ? styles.inactive : styles.active
              }`}
              onClick={() => setFilter('pendingApproval')}
              disabled={filter === 'pendingApproval'}
            >
              Pending approval
            </button>

          </div>
        </div>

        {/* TABLE */}
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>{columnHeader('Status', 'status', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('IFA Code', 'ifaCode', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('IFA Name', 'ifaName', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('FSP', 'company', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('Date Created', 'dateCreated', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('Date Modified', 'dateModified', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('Date Published', 'datePublished', orderingBy, sortAscending, orderBy)}</th>
              <th>{columnHeader('Modified By', 'modifiedBy', orderingBy, sortAscending, orderBy)}</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {fetchingProfiles ? (
              <tr>
                <td colSpan={9}><Spinner /></td>
              </tr>
            ) : profiles.length === 0 ? (
              <tr>
                <td colSpan={9} style={{ textAlign: 'center', padding: '20px', color: '#778286' }}>No profiles found</td>
              </tr>
            ) : (
              profiles.map((p, i) => renderProfile(p, i, setEditorAdviserId))
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
          <Pager
            totalPages={numPages}
            currentPage={currentPage}
            loadPage={setPage}
          />
        </div>

      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  const { set } = actions
  return bindActionCreators({
    setEditorAdviserId: set.adviserId
  }, dispatch)
}

PendingApprovalProfilesList.propTypes = {
  profiles: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  filter: PropTypes.string,
  setSearchTerm: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  fetchingProfiles: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  numPages: PropTypes.number.isRequired,
  orderBy: PropTypes.func.isRequired,
  orderingBy: PropTypes.string.isRequired,
  sortAscending: PropTypes.bool.isRequired
}

export default connect(null, mapDispatchToProps)(PendingApprovalProfilesList)
